import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { useQueryParams, makeQueryStrings } from '../utils/queryParams';
import {
  addErrorMessage,
  setOnCloseErrorModal,
  setSessionKey,
} from '../modules/app';
import {
  handleQueryParamsFlight,
  setQueryParamsValidatedFlight,
  fetchEssentialFlightStateFromSession,
} from '../modules/flight';
import {
  handleQueryParamsHotel,
  setQueryParamsValidatedHotel,
  fetchEssentialHotelStateFromSession,
} from '../modules/hotel';
import {
  handleQueryParamsPlanList,
} from '../modules/plan';
import {
  handleQueryParamsPlanDetail,
  handleQueryParamsEntryConfirm,
} from '../modules/planDetail';
import Loading from './atoms/Loading';
import { createKeybyTimestamp, validateSessionkey } from '../utils/localStorage';
import { ERROR_STATUS_MESSAGE_MAP, BASENAME } from '../constants';

const selector = (state) => ({
  flight: state.flight,
  hotel: state.hotel,
});

const QueryParams = () => {
  const history = useHistory();
  const location = useLocation();
  const { flight, hotel } = useSelector(selector);
  const {
    queryParamsValidated: queryParamsValidatedFlight,
  } = flight;
  const {
    queryParamsValidated: queryParamsValidatedHotel,
  } = hotel;

  const query = useQueryParams();
  const dispatch = useDispatch();

  const { pathname } = location;

  // handle k(=sessionKey)
  let { k, error: errorStatus, errorMsg } = query;

  useEffect(() => {

    if (errorStatus) {
      const errorMessage = (errorStatus === '999') ? (errorMsg || ERROR_STATUS_MESSAGE_MAP.fallback) : (ERROR_STATUS_MESSAGE_MAP[errorStatus] || ERROR_STATUS_MESSAGE_MAP.fallback);
      dispatch(addErrorMessage(errorMessage));
      const searchParams = { ...query };
      delete searchParams.error;
      delete searchParams.errorMsg;
      const searchString = makeQueryStrings(searchParams);
      const topUrl = `${BASENAME}/search${searchString ? `?${searchString}` : ''}`;
      dispatch(setOnCloseErrorModal(
        () => window.open(topUrl, '_self')
      ));
      return;
    }

    if (k) {
      if (pathname !== '/search' && pathname !== '/searcha') {
        if (!validateSessionkey(k)) {
          history.push('/timeout');
          return;
        }

        dispatch(fetchEssentialFlightStateFromSession(k));
        dispatch(fetchEssentialHotelStateFromSession(k));
      }
    } else {
      k = createKeybyTimestamp();
    }
    setSessionKey(k);

    switch (pathname) {

    case '/search': {
      dispatch(handleQueryParamsFlight(query));
      dispatch(handleQueryParamsHotel(query));
      break;
    }

    case '/searcha': {
      dispatch(handleQueryParamsFlight(query));
      dispatch(handleQueryParamsHotel(query));
      break;
    }

    case '/plan_list': {
      dispatch(handleQueryParamsPlanList(query));
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }

    case '/plan_detail': {
      dispatch(handleQueryParamsPlanDetail(query));
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }

    case '/entry_confirm': {
      dispatch(handleQueryParamsEntryConfirm(query));
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }

    default: {
      dispatch(setQueryParamsValidatedFlight(true));
      dispatch(setQueryParamsValidatedHotel(true));
      break;
    }
    }
  }, [pathname]);

  if (!errorStatus && !(queryParamsValidatedFlight && queryParamsValidatedHotel)) {
    return (
      <Loading show progressRate={0} />
    );
  }

  return null;

};

export default QueryParams;
